import { render, staticRenderFns } from "./KompentensiTable.vue?vue&type=template&id=04d06b1f&"
import script from "./KompentensiTable.vue?vue&type=script&lang=js&"
export * from "./KompentensiTable.vue?vue&type=script&lang=js&"
import style0 from "./KompentensiTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports